// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2y5F0","footer":"ModalFilter_footer__3IBXN"};